import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Universalpageheader from '../Headers/universalpageheader';
import Productcard from '../Products/productcard';
import { Alert, AlertTitle, Button, CircularProgress } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import Searchbar from '../Components/searchbar';
import _ from 'lodash';
import constants from "./../Utils/constants.json"
import { addKECode, isEmail, isName, isPhone, removeFromStore } from '../Utils/fn';
import Select from 'react-select';
import useCart from '../../hooks/useCart';
import { currencyseperator } from '../Utils/functions';
import { setCartItems } from '../../store/cartItems';
import Popupdialog from '../Components/popupcomponent';
import Loadingspinner from '../Components/loading';
import { setAlert } from '../../store/alert';
import { setUser, setLoggedIn } from '../../store/user';
import { IconButton, InputAdornment } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import fetch from '../Utils/fetch';
import SignIn from '../Common/login';


function Checkoutpage() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const currentLocation = useSelector((state) => state.location.data);

    const { user, loggedIn } = useSelector((state) => state.user);
    const webSettings = useSelector(state => state.webSettings.data);
    const subProducts = useSelector((state) => state.subProducts.data);
    const cartItems = useSelector(state => state.cartItems.data);
    const { items, quantity, total } = useCart(cartItems);
    const [locationsarray, setlocationsarray] = useState([]);

    const [loading, setLoading] = useState(false);
    const [showsearchbar, setshowsearchbar] = useState(false);
    const [showconfirmorder, setshowconfirmorder] = useState(false);

    const [name, setName] = useState(user.fullName || '');
    const [phone, setPhone] = useState(user.mobileNumber ? user.mobileNumber.replace('+', '') : '254');
    const [email, setEmail] = useState(user.email || '');
    const [branch, setBranch] = useState(currentLocation?.mainLocation || '');
    const [location, setLocation] = useState(currentLocation?.mainLocation || '');
    const [comments, setComments] = useState('');
    const [password, setPassword] = useState('');
    const [showPass, setShowPass] = useState(false);
    const [showlogin, setshowlogin] = useState(false)



    const [requestmade, setrequestmade] = useState(false);
    const [paymentsuccess, setpaymentsuccess] = useState(false);
    const [orderResponse, setOrderResponse] = useState(null);


    useEffect(() => {
        window.scrollTo(0, 0);
        const formatted_locations = webSettings.locations.map((obj) => ({ label: obj.locationName, value: obj.mainLocation }))
        setBranch(formatted_locations.find(loc => loc.value === currentLocation?.mainLocation))
        setlocationsarray(formatted_locations)
    }, []);

    function clearCartItems() {
        removeFromStore(constants.CART_ITEMS);
        dispatch(setCartItems([]));
    }

    async function submit(e) {
        setshowconfirmorder(false)
        if (loading) {
            dispatch(setAlert({ type: 'error', message: 'Please wait!!' }));
            return;
        }
        let res;

        if ((res = isName(name)) === true) {
            if ((res = isPhone(phone)) === true) {
                if ((res = isEmail(email)) === true) {
                    if (!loggedIn && password.length < 4) {
                        dispatch(setAlert({ type: 'error', message: 'Please enter a valid password (min 4 characters)' }));
                        return;
                    }
                    if (location.length > 3) {
                        setLoading(true);
                        dispatch(setAlert('Processing...'));

                        try {
                            if (!loggedIn) {
                                dispatch(setAlert('Creating your account...'));
                                const regRes = await fetch.get('requestCustomerAccount', {
                                    customerName: name,
                                    customerEmail: email,
                                    customerPhone: addKECode(phone),
                                    password: password
                                });

                                if (!regRes.error) {
                                    const loginRes = await fetch.get('getLogin', {
                                        username: email,
                                        password: password
                                    });

                                    if (loginRes.data && loginRes.data.token) {
                                        const userData = loginRes.data;
                                        dispatch(setUser(userData));
                                        dispatch(setLoggedIn(true));
                                    }
                                }
                            }

                            dispatch(setAlert('Placing order. Please wait'));
                            let cart_items = [];
                            cartItems.forEach((item, index) => {
                                let obj = {};
                                obj.suom = item.suom;
                                obj.item_code = item.item_code;
                                obj.item_price = parseFloat(item.itemPrice);
                                obj.item_name = item.item_name;
                                obj.quantity = item.quantity;
                                obj.amount_value = parseFloat((parseFloat(item.itemPrice) * item.quantity).toFixed(2));
                                cart_items.push(obj);
                            });

                            const resOrder = await fetch.get('completeOfflineOrder', {
                                client_name: name,
                                email,
                                phone: addKECode(phone),
                                branch,
                                pick_location: location,
                                ledger_number: loggedIn ? user.LEDGER_NUMBER : 'GUEST',
                                comment: comments,
                                cart_items: JSON.stringify(cart_items),
                            });


                            if (!resOrder.error) {
                                setOrderResponse(resOrder.list[0]);
                                clearCartItems();
                                lipaNaMpesa(resOrder.list[0])
                                dispatch(setAlert('Done placing order'));
                            } else {
                                if (resOrder.message == "Invalid or expired token") {
                                    dispatch(setLoggedIn(false));
                                    dispatch(setUser({}));
                                    setshowlogin(true)
                                } else {
                                    dispatch(setAlert({ type: 'error', message: resOrder.message }));
                                }
                            }

                        } catch (err) {
                            setLoading(false);
                            dispatch(setAlert({ type: 'error', message: 'Error checking out. ' + err.message }));
                        }
                        return;
                    } else {
                        res = 'Pick up location is required or too short';
                    }
                }
            }
        }
        dispatch(setAlert({ type: 'error', message: res }));
    }



    function lipaNaMpesa(tempmpesadata) {
        const finalempesadata = {
            name: name,
            order_no: tempmpesadata.ORDER_NUMBER.toString(),
            order_type: tempmpesadata.ORDER_TYPE.toString(),
            amount: tempmpesadata.AMOUNT.toString(),
            phone_number: addKECode(phone).toString(),
            location: branch
        }

        fetch
            .post('pay-goods-online', finalempesadata)
            .then((res) => {
                setLoading(false)
                if ('object' === typeof res) {
                    if (res.error === false) {
                        res.message = 'Request accepted for processing. Please check your phone.';
                    }
                    setrequestmade(true)
                    setpaymentsuccess(true)

                } else {
                    dispatch(setAlert({ type: 'error', message: 'Unknown error occurred performing operation.' }));
                }
            })
            .catch((err) => {
                dispatch(setAlert({ type: 'error', message: 'object' === typeof err ? err.message : err }));
                setLoading(false)
            });
    }

    const onsuccesslogin = () => {
        window.location.reload();
    }


    const disable_button = cartItems?.length < 1 || !name || !phone || !email || !location || !branch || loading

    return (
        <div className="homebody">
            {showlogin && <SignIn ondismiss={() => setshowlogin(false)} onsuccesslogin={onsuccesslogin} />}
            {showsearchbar && <Searchbar dismissmodals={() => setshowsearchbar(false)} products={subProducts?.flatMap((obj) => obj.items)} />}
            <Universalpageheader onshowsearch={() => setshowsearchbar(true)} pagename={"Place your order"} withbackicon={true} />
            {loading && <Loadingspinner />}
            {showconfirmorder &&
                <Popupdialog
                    toptext={"Confirm Order!"}
                    question={"Are you sure you want to place this order?"}
                    oncancel={() => setshowconfirmorder(false)}
                    onsuccess={submit}
                    successtext={"Place Order"} />
            }
            {paymentsuccess &&
                <Popupdialog
                    toptext={"Payment Request Sent!"}
                    question={"Your payment request has been sent to your phone. After completing the payment, you can view your order status in the orders page."}
                    oncancel={() => navigate("/orders")}
                    onsuccess={() => navigate("/orders")}
                    successtext={"View My Orders"} />
            }

            <div className='pagemini' style={{ paddingTop: 3, paddingBottom: 3 }}>
                <div style={{ fontSize: 12, display: "flex", flexWrap: "wrap" }}>If you proceed you are automatically accepting our <a>Terms & Conditions</a></div>
                {orderResponse &&
                    <Alert severity="success" sx={{ mt: 2, borderRadius: 2 }}>
                        <AlertTitle>Success</AlertTitle>
                        Order #{orderResponse.ORDER_NUMBER} placed successfully. <br />
                        <b>Total: {webSettings.CURRENCY} {currencyseperator(orderResponse.AMOUNT)}</b><br />
                        Complete payment on phone <b>{addKECode(phone)}</b>
                    </Alert>
                }
            </div>
            {!orderResponse && (
                <>
                    <div className="cartsummarytitle">ORDER SUMMARY</div>
                    <div className='pagemini'>
                        <div className='wrapcheckouttitle'>
                            <div className='titleleft'>Item's total ({cartItems?.length})</div>
                            <div style={{ fontWeight: "bold", fontSize: 13 }}>{webSettings.CURRENCY} {currencyseperator(total)}</div>
                        </div>
                        <div className='wrapcheckouttitle'>
                            <div className='titleleft'>Delivery fees</div>
                            <div style={{ fontWeight: "bold", fontSize: 13 }}>__</div>
                        </div>
                        <hr />
                        <div className='wrapcheckouttitle'>
                            <div className='titleleft'>Total</div>
                            <div style={{ fontWeight: "bold", fontSize: 13 }}>{webSettings.CURRENCY} {currencyseperator(total)}</div>
                        </div>
                    </div>

                    <div className="cartsummarytitle">CUSTOMER DETAILS</div>
                    <div className='pagemini'>
                        {!loggedIn && (
                            <div style={{ backgroundColor: '#f0f7ff', padding: '15px', borderRadius: '12px', marginBottom: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', border: '1px solid #e0efff' }}>
                                <div>
                                    <div style={{ fontSize: '13px', fontWeight: 'bold', color: '#1a1a1a' }}>Already have an account?</div>
                                    <div style={{ fontSize: '11px', color: '#666' }}>Sign in to track your orders faster.</div>
                                </div>
                                <div onClick={() => setshowlogin(true)} style={{ backgroundColor: '#fff', color: '#007bff', padding: '8px 15px', borderRadius: '8px', fontSize: '11px', fontWeight: 'bold', textDecoration: 'none', border: '1px solid #007bff' }}>
                                    SIGN IN
                                </div>
                            </div>
                        )}

                        <label className='label' htmlFor='name'>
                            Full Name *
                        </label>
                        <input disabled={loggedIn} onInput={(e) => setName(e.target.value)} readOnly={loggedIn} className={`input ${loggedIn ? 'readonly-input' : ''}`} type='text' id='name' value={name} placeholder="John Doe" />

                        <label className='label' htmlFor='phone'>
                            Phone Number *
                        </label>
                        <input onInput={(e) => setPhone(e.target.value)} className='input' type='text' id='phone' value={phone} placeholder="07XXXXXXXX" />

                        <label className='label' htmlFor='email'>
                            Email Address *
                        </label>
                        <input disabled={loggedIn} onInput={(e) => setEmail(e.target.value)} readOnly={loggedIn} className={`input ${loggedIn ? 'readonly-input' : ''}`} type='email' id='email' value={email} placeholder="john@example.com" />

                        {!loggedIn && (
                            <>
                                <label className='label' htmlFor='password'>
                                    Create Password *
                                </label>
                                <div style={{ position: 'relative' }}>
                                    <input
                                        onInput={(e) => setPassword(e.target.value)}
                                        className='input'
                                        type={showPass ? 'text' : 'password'}
                                        id='password'
                                        value={password}
                                        placeholder="••••••••"
                                        style={{ paddingRight: '45px' }}
                                    />
                                    <div
                                        onClick={() => setShowPass(!showPass)}
                                        style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer', color: '#999', display: 'flex', alignItems: 'center' }}
                                    >
                                        {showPass ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                                    </div>
                                </div>
                                <div style={{ fontSize: '10px', color: '#999', marginTop: '5px' }}>Your account will be created automatically.</div>
                            </>
                        )}
                    </div>

                    <div className="cartsummarytitle">ADDRESS & DELIVERY</div>
                    <div className='pagemini'>
                        <label className='label' htmlFor='branch'>
                            Preferred Branch *
                        </label>
                        <div style={{ fontSize: 13 }}>
                            <Select required menuPlacement="auto" options={locationsarray} onChange={(e) => setBranch(e.value)} />
                        </div>
                        <label className='label' htmlFor='location'>
                            Pickup Location *
                        </label>
                        <input onInput={(e) => setLocation(e.target.value)} className='input' type='text' id='location' value={location} placeholder="Specific location details..." />

                        <label className='label' htmlFor='comments'>
                            Additional Comments
                        </label><br />
                        <textarea onInput={(e) => setComments(e.target.value)} className='input' id='comments' value={comments} placeholder="Any instructions?" rows={3} style={{ height: 'auto', padding: '10px' }} />
                    </div>

                    <div className='quantitypopupdiv'>
                        <Button onClick={() => setshowconfirmorder(true)} disabled={disable_button} sx={{ height: 50, borderRadius: '50px' }} fullWidth variant="contained">Confirm Order</Button>
                    </div>
                </>
            )}

            {orderResponse && (
                <div className='quantitypopupdiv'>
                    <Button onClick={() => lipaNaMpesa(orderResponse)} disabled={loading} sx={{ height: 50, borderRadius: '50px', mb: 2 }} fullWidth variant="contained" color="success">PAY VIA M-PESA NOW</Button>
                    <Button onClick={() => window.location.href = '/'} sx={{ height: 50, borderRadius: '50px' }} fullWidth variant="outlined">GO HOME</Button>
                </div>
            )}

        </div>
    );
}


export default Checkoutpage;
